import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SuccessComponent } from '../shared/modals/success/success.component';
import { ErrorComponent } from '../shared/modals/error/error.component';
import { CreateSeasonComponent } from '../shared/modals/create-season/create-season.component';
import { LoginComponent } from '../shared/modals/login/login.component';
import { CreateLeagueComponent } from '../shared/modals/create-league/create-league.component';
import { CreatePlayerComponent } from '../shared/modals/create-player/create-player.component';
import { ReviewDetailsComponent } from '../shared/modals/review-details/review-details.component';
import { CreateScorerComponent } from '../shared/modals/create-scorer/create-scorer.component';
import { CreateLeaguePlayerComponent } from '../shared/modals/create-league-player/create-league-player.component';
import { AssignScorerComponent } from '../shared/modals/assign-scorer/assign-scorer.component';
import { AssignPlayerComponent } from '../shared/modals/assign-player/assign-player.component';
import { UpdateLeagueComponent } from '../shared/modals/update-league/update-league.component';
import { UpdateLeagueGameComponent } from '../shared/modals/update-league-game/update-league-game.component';
import { LoadingSpinnerComponent } from '../shared/modals/loading-spinner/loading-spinner.component';
// import { AddVestComponent } from '../shared/modals/add-vest/add-vest.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
    
  modalRefSucess!: BsModalRef;
  modalRefError!: BsModalRef;
  modalRefResponse!: BsModalRef;
  modalRefCreateSeason!: BsModalRef;
  modalRefCreateSeasonLeague!: BsModalRef;
  modalRefLogin!: BsModalRef;
  modalRefRegister!: BsModalRef;
  modalRefCreateScorer!: BsModalRef;
  modalRefCreatePlayer!: BsModalRef;
  modalRefReviewDetails!: BsModalRef;
  modalRefCreateLeaguePlayer!: BsModalRef;
  modalRefAssignScorer!: BsModalRef;
  modalRefAssignPlayer!: BsModalRef;
  modalRefUpdateSeasonLeague!: BsModalRef;
  modalRefUpdateLeagueGame!: BsModalRef;
  modalRefLoadingSpinner!: BsModalRef;

  constructor(
    private modalService: BsModalService
  ) {}


  openLogin(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefLogin = this.modalService.show(LoginComponent, config);
  }

	hideLogin(){
    if(this.modalRefLogin){
			this.modalRefLogin.hide();
    }
	}
    
  successModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered success-modal'
    }

    return this.modalRefSucess = this.modalService.show(SuccessComponent, config);
  }

	hideSuccessModal(){
    if(this.modalRefSucess){
			this.modalRefSucess.hide();
    }
	}

  errorModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal modal-dialog-centered success-modal'
    }

    return this.modalRefError = this.modalService.show(ErrorComponent, config);
  }

	hideErrorModal(){
    if(this.modalRefError){
			this.modalRefError.hide();
    }
	}

  openCreateSeason(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateSeason = this.modalService.show(CreateSeasonComponent, config);
  }

	hideCreateSeason(){
    if(this.modalRefCreateSeason){
			this.modalRefCreateSeason.hide();
    }
	}

  openCreateSeasonLeague(season){
    const initialState = {
      season
    }
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered create-league-modal'
    }

    return this.modalRefCreateSeasonLeague = this.modalService.show(CreateLeagueComponent, config);
  }

	hideCreateSeasonLeague(){
    if(this.modalRefCreateSeasonLeague){
			this.modalRefCreateSeasonLeague.hide();
    }
	}

  openUpdateSeasonLeague(season, league){
    const initialState = {
      season,
      league
    }
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered create-league-modal'
    }

    return this.modalRefUpdateSeasonLeague = this.modalService.show(UpdateLeagueComponent, config);
  }

	hideUpdateSeasonLeague(){
    if(this.modalRefUpdateSeasonLeague){
			this.modalRefUpdateSeasonLeague.hide();
    }
	}

  openCreateScorer(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateScorer = this.modalService.show(CreateScorerComponent, config);
  }

	hideCreateScorer(){
    if(this.modalRefCreateScorer){
			this.modalRefCreateScorer.hide();
    }
	}

  openCreatePlayer(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreatePlayer = this.modalService.show(CreatePlayerComponent, config);
  }

	hideCreatePlayer(){
    if(this.modalRefCreatePlayer){
			this.modalRefCreatePlayer.hide();
    }
	}

  openCreateLeaguePlayer(league){
    const initialState = {
      league
    }
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      initialState,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateLeaguePlayer = this.modalService.show(CreateLeaguePlayerComponent, config);
  }

	hideCreateLeaguePlayer(){
    if(this.modalRefCreateLeaguePlayer){
			this.modalRefCreateLeaguePlayer.hide();
    }
	}

  openReviewDetails(payload, type, league){
    const initialState = {
      payload,
      type,
      league
    };

    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefReviewDetails = this.modalService.show(ReviewDetailsComponent, config);
  }

	hideReviewDetails(){
    if(this.modalRefReviewDetails){
			this.modalRefReviewDetails.hide();
    }
	}

  openAssignScorers(scorers, league, seasonId){
    const initialState = {
      scorers,
      league,
      seasonId
    };

    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefAssignScorer = this.modalService.show(AssignScorerComponent, config);
  }

	hideAssignScorers(){
    if(this.modalRefAssignScorer){
			this.modalRefAssignScorer.hide();
    }
	}

  openAssignPlayers(players, leagueId, league, leaguePlayers){
    const initialState = {
      players,
      leagueId,
      league,
      leaguePlayers
    };

    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefAssignPlayer = this.modalService.show(AssignPlayerComponent, config);
  }

	hideAssignPlayers(){
    if(this.modalRefAssignPlayer){
			this.modalRefAssignPlayer.hide();
    }
	}

  openUpdateLeagueGame(game, league){
    const initialState = {
      game,
      league
    };

    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefUpdateLeagueGame = this.modalService.show(UpdateLeagueGameComponent, config);
  }

	hideUpdateLeagueGame(){
    if(this.modalRefUpdateLeagueGame){
			this.modalRefUpdateLeagueGame.hide();
    }
	}

  showLoadingSpinner(){
		const config: any = {
			backdrop: true,
			ignoreBackdropClick: true,
			keyboard: false,
			class: 'modal-dialog-centered loading-spinner'
		}

		return this.modalRefLoadingSpinner = this.modalService.show(LoadingSpinnerComponent, config);
  }

  hideLoadingSpinner(){
    if(this.modalRefLoadingSpinner){
			this.modalRefLoadingSpinner.hide();
    }
	}
}
